import { Component, Input, Output, TemplateRef, EventEmitter } from '@angular/core';

@Component({
	selector: 'pannel',
	templateUrl: 'pannel.html'
})
export class PannelComponent {
	constructor() {
	}

	public _pannelClass: string = 'panel panel-default';
	@Input() set pannelClass(value: string | undefined) {
		if (value) {
			this._pannelClass = 'panel panel-default ' + value;
		} else {
			this._pannelClass = 'panel panel-default';
		}
	}

	@Input() title!:string;
	@Input() expandable:boolean = false;

	@Input() headerTemplate: TemplateRef<any> | null = null; 

	@Input() folded: boolean = false;	
	@Output() foldedChange = new EventEmitter<boolean>();

	toggleDisplay() {
		if (this.expandable) {
			this.folded = !this.folded;
			this.foldedChange.emit(this.folded);
		}
	}
}